import dispatcher from '../dispatcher';
import scrollStore from '../scroll/scroll.store';
import firstScrollStore from '../scroll/first-scroll.store';

var atTop = true;
var pw;

var _handleScroll = function() {
	var scrolled = scrollStore.getData().top;

	if (scrolled <= 0 && !atTop) {
		pw.classList.remove('scrolled');
		atTop = true;
		dispatcher.dispatch({
			type: 'first-scroll:false'
		});
	} else if (scrolled > 0 && atTop) {
		pw.classList.add('scrolled');
		atTop = false;
		dispatcher.dispatch({
			type: 'first-scroll:true'
		});
	}
}

var init = function() {
	pw = document.getElementsByClassName('page-wrapper')[0];
	_handleScroll();
	scrollStore.subscribe(_handleScroll);
}

export default {
	init: init
};